import React from "react";
import { useTranslation } from "react-i18next";
import { Divider, Segment } from "semantic-ui-react";
import ScalapayFrase from "../common/ScalapayFrase";

/**
 * Riepilogo prezzo di una "Offerta / Pacchetto".
 *
 * Variante di Prezzo2 senza la moltiplicazione per il numero di allievi: il listino di un
 * pacchetto è indicizzato per numero di persone, quindi l'importo è già il totale della comitiva.
 * Per lo stesso motivo spariscono anche le etichette "{numAllievi} x".
 */
const PrezzoOfferta = ({ listinoInUso, numAllievi, datiScuola }) => {
  const { t } = useTranslation([datiScuola.customTranslationNamespace]);

  if (!listinoInUso || Object.keys(listinoInUso).length === 0) return <></>;

  const saldo = listinoInUso.prezzo - listinoInUso.prezzoPag;

  return (
    <Segment
      textAlign={(datiScuola.tipoBanca_2 ?? 0) > 0 ? "left" : "right"}
      basic
      style={{ marginTop: "0px", paddingLeft: "0px" }}
    >
      <Divider />
      {listinoInUso.prezzo < listinoInUso.prezzoListino && (
        <div className="riga-prezzo">
          <span className="prezzo_parziale label-prezzo">
            {t("prezzo_listino")}
          </span>
          <span className="prezzo_parziale prezzo-barrato">
            {datiScuola.valuta} {listinoInUso.prezzoListino.toFixed(2)}
          </span>
        </div>
      )}
      <div
        style={{ display: "flex", justifyContent: "space-between" }}
        className="riga-prezzo"
      >
        <span className="prezzo_totale label-prezzo">
          {t("prezzo_pacchetto", { count: numAllievi })}
        </span>
        <span className="prezzo_totale">
          {datiScuola.valuta} {listinoInUso.prezzo.toFixed(2)}
        </span>
      </div>
      {listinoInUso.prezzo !== listinoInUso.prezzoPag && (
        <>
          <Divider />
          <div className="riga-prezzo">
            <span className="prezzo_parziale label-prezzo">
              {t("acconto_da_pagare")}
            </span>
            <span className="prezzo_parziale">
              {datiScuola.valuta} {listinoInUso.prezzoPag.toFixed(2)}
            </span>
          </div>
          <div className="riga-prezzo">
            <span className="prezzo_parziale label-prezzo">{t("saldo")}</span>
            <span className="prezzo_parziale">
              {datiScuola.valuta} {saldo.toFixed(2)}
            </span>
          </div>
        </>
      )}
      {datiScuola.tipoBanca_2 > 0 && (
        <div style={{ paddingTop: "28px" }}>
          <ScalapayFrase
            prezzo={(listinoInUso.prezzoPag / 3).toFixed(2)}
            end={true}
          />
        </div>
      )}
      <Divider />
    </Segment>
  );
};

export default PrezzoOfferta;
